@if (filters.length) {
  <div
    #scroller
    class="mp-picker"
    (pointerdown)="onPointerDown($event)"
    (pointermove)="onPointerMove($event)"
    (pointerup)="onPointerUp($event)"
    (pointerleave)="onPointerUp($event)"
    >
    @for (f of filters; track f) {
      <button
        #chip
        type="button"
        class="mp-chip"
        [attr.data-key]="f.dateKey + '|' + f.gameType"
        [class.active]="selected?.dateKey === f.dateKey && selected?.gameType === f.gameType"
        (click)="onPick(f)"
        >
        {{ f.label }}
      </button>
    }
  </div>
}
